var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.718,
    height: 75.096,
    viewBox: "0 0 65.718 75.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-alt",
    transform: "translate(-59.1 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_271",
    "data-name": "Caminho 271",
    d: "M63.806,99.054a7.044,7.044,0,0,0,7.042,7.042h42.237a7.044,7.044,0,0,0,7.042-7.042h0V49.774H63.806ZM103.69,61.506a2.353,2.353,0,0,1,4.706,0V94.364a2.353,2.353,0,0,1-4.706,0Zm-14.085,0a2.353,2.353,0,1,1,4.706,0V94.364a2.353,2.353,0,1,1-4.706,0Zm-14.068,0a2.353,2.353,0,1,1,4.706,0V94.364a2.353,2.353,0,1,1-4.706,0Zm46.927-25.816H104.859l-1.385-2.737A3.521,3.521,0,0,0,100.319,31H83.565a3.478,3.478,0,0,0-3.137,1.952l-1.385,2.737H61.453A2.35,2.35,0,0,0,59.1,38.042v4.689a2.35,2.35,0,0,0,2.353,2.353h61.011a2.35,2.35,0,0,0,2.353-2.353V38.042A2.35,2.35,0,0,0,122.464,35.689Z",
    transform: "translate(0 0)",
    fill: "#ffc5d0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c9c5164790d480fd0c94a6f4b68f7c07.svg";
export { ForwardRef as ReactComponent };